import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as _ from 'lodash-es';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'together-auction-dip-eligibility',
    templateUrl: './dip.eligibility.component.html',
    standalone: false
})
export class TogetherAuctionDIPEligibilityComponent implements OnInit {
    closeResult: string;

    @Input() stage;
    @Input() incoming_case_id: string;
    @Input() property_type: string;
    @Input() is_dip: boolean;
    _forwardText: string = 'I agree, let\'s get started';
    _backwardText: string = 'I\'d like to speak to the team';
    _showAction: boolean = false;
    _showForward: boolean = true;
    _showBackward: boolean = false;
    @Output() stage_changing = new EventEmitter();

    _handleForward() {
        this.stage_changing.emit(this.stage.forward_stage.reference);
    }

    _handleBackward() {
        this.stage_changing.emit(this.stage.backward_stage.reference);
    }
    open(content) {
        this.modalService.open(content).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
    }

    constructor(private modalService: NgbModal) { }
    ngOnInit() {
        window.scrollTo(0, 0);
    }
}
